import dayjs from 'dayjs';

export interface IAuditTrail {
  id?: number;
  entityName?: string;
  entityId?: number;
  action?: 'INSERT' | 'UPDATE' | 'DELETE';
  fieldName?: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  changedBy?: string;
  changedAt?: dayjs.Dayjs | string;
}

export const defaultValue: Readonly<IAuditTrail> = {};
